import { render } from "./MeviusStoryTalentList.vue?vue&type=template&id=1321c017&scoped=true&ts=true&lang=pug"
import script from "./MeviusStoryTalentList.vue?vue&type=script&lang=ts"
export * from "./MeviusStoryTalentList.vue?vue&type=script&lang=ts"

import "./MeviusStoryTalentList.vue?vue&type=style&index=0&id=1321c017&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1321c017"]])

export default __exports__